import { createContext } from "react"

const HeaderContext = createContext({
  collapsed: false,
  sticky: false,
})

export default HeaderContext
